var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from './utils/axios';
import { downloadFile } from './utils/utils';
export function getAffaire(AffaireId, ClientId) {
    return __awaiter(this, void 0, void 0, function () {
        var params, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = { ClientId: ClientId };
                    if (AffaireId) {
                        params.AffaireId = AffaireId;
                    }
                    return [4 /*yield*/, axios.get('/affaire/get', { params: params })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function getAffaireListe(ClientId, CollaborateurId, _a) {
    if (ClientId === void 0) { ClientId = null; }
    if (CollaborateurId === void 0) { CollaborateurId = null; }
    var _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.itemByPage, itemByPage = _c === void 0 ? 10 : _c, _d = _a.filtres, filtres = _d === void 0 ? null : _d, _e = _a.order, order = _e === void 0 ? null : _e;
    return __awaiter(this, void 0, void 0, function () {
        var params, data;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    params = __assign({}, filtres);
                    params.Page = page;
                    params.ItemByPage = itemByPage;
                    if (ClientId) {
                        params.ClientId = ClientId;
                    }
                    if (CollaborateurId) {
                        params.CollaborateurId = CollaborateurId;
                    }
                    if (order && order.by) {
                        params[order.isAsc ? 'OrderBy' : 'OrderByDesc'] = order.by;
                    }
                    return [4 /*yield*/, axios.get('/affaire/liste', {
                            params: params,
                        })];
                case 1:
                    data = (_f.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function getInfos(AffaireId) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get('/affaire/infos', {
                        params: {
                            AffaireId: AffaireId
                        }
                    })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function generateDevis(_a) {
    var AffaireId = _a.AffaireId, Titre = _a.Titre, Numero = _a.Numero, Date = _a.Date;
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, axios.post('/affaire/save_devis', {
                        AffaireId: AffaireId,
                        Titre: Titre,
                        Numero: Numero,
                        Date: Date
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data.type !== 'error'];
            }
        });
    });
}
export function postAffaire(ClientId, IdAffaire, affaire) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.post('/affaire/store', {
                        affaire: __assign({ ClientId: affaire.ClientId ? affaire.ClientId : ClientId, IdAffaire: IdAffaire }, affaire),
                    })];
                case 1:
                    data = (_a.sent()).data;
                    if (!IdAffaire && data.IdAffaire) {
                        window.location.href = "/affaire/fiche/".concat(data.IdAffaire);
                    }
                    return [2 /*return*/, { isOk: data.type !== 'error' }];
            }
        });
    });
}
export function clonerAffaire(_a) {
    var AffaireId = _a.AffaireId, OtherClient = _a.OtherClient, ClientId = _a.ClientId, DuplicateEquipe = _a.DuplicateEquipe, CollaborateurProprietaireId = _a.CollaborateurProprietaireId, Libelle = _a.Libelle, MoisSignature = _a.MoisSignature;
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, axios.post('/affaire/cloner', {
                        AffaireId: AffaireId,
                        OtherClient: OtherClient,
                        ClientId: ClientId,
                        DuplicateEquipe: DuplicateEquipe,
                        CollaborateurProprietaireId: CollaborateurProprietaireId,
                        Libelle: Libelle,
                        MoisSignature: MoisSignature,
                    })];
                case 1:
                    data = (_b.sent()).data;
                    if (data.IdAffaire) {
                        window.location.href = '/affaire/fiche/' + data.IdAffaire;
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function reouvrirAffaire(AffaireId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.post('/affaire/reouvrir', {
                        AffaireId: AffaireId,
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function deleteAffaire(AffaireId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.delete('/affaire/delete?AffaireId=' + AffaireId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function postEtapeAffaire(AffaireId, Etape, Etat) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.post('/affaire/store_etape', {
                        AffaireId: AffaireId,
                        Etape: Etape,
                        Etat: Etat,
                    })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, { isOk: data.type !== "error" }];
            }
        });
    });
}
export function exportAffaire(ClientId, CollaborateurId, filtres) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get('/affaire/export', {
                        params: __assign({ ClientId: ClientId, CollaborateurId: CollaborateurId }, filtres),
                    })];
                case 1:
                    data = (_a.sent()).data;
                    downloadFile({ data: data, fileName: 'affaires', fileType: 'text/csv' });
                    return [2 /*return*/];
            }
        });
    });
}
export function getAffaireEquipeListe(AffaireId) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get('/affaire/equipe?AffaireId=' + AffaireId)];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function postAffaireEquipe(AffaireId, CollaborateurId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (CollaborateurId == null) {
                        return [2 /*return*/, axios.get('/utils/error?Message=Veuillez sélectionner un collaborateur.')];
                    }
                    return [4 /*yield*/, axios.post('/affaire/equipe/store', {
                            AffaireId: AffaireId,
                            CollaborateurId: CollaborateurId,
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function deleteAffaireEquipe(IdAffaireCollaborateur) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.delete('/affaire/equipe/delete?IdAffaireCollaborateur=' + IdAffaireCollaborateur)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function changeProprietaire(AffaireId, CollaborateurId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.post('/affaire/equipe/store_proprietaire', {
                        AffaireId: AffaireId,
                        CollaborateurId: CollaborateurId,
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=affaire.js.map